import axios from 'axios';
import { useMutation } from 'react-query';

export function useGetZoomToken() {
  return useMutation({
    mutationFn: async ({ url, token }: { url: string, token: string }) => {
      const response = await axios.get(url, {
        headers: {
          Authorization: token,
        },
      });

      return response.data;
    },
  });
}